import { makeApiRequests } from './api';
import { ENDPOINTS } from './constants';

export const fetchBrowseInventory = async ({
  preset,
  filters,
  query,
  sortRules,
  pageNumber,
  pageSize,
  signal
}) => {
  return makeApiRequests({
    endpoint: ENDPOINTS.INVENTORY_BROWSE,
    requestBody: {
      preset,
      filters,
      query,
      sortRules,
      pageNumber,
      pageSize
    },
    signal
  });
};

export const exportBrowseInventory = async ({
  preset,
  filters,
  query,
  sortRules,
  exportType,
  excludedIds,
  hiddenColumns,
  salesLocationChoices
}) => {
  return makeApiRequests({
    endpoint: ENDPOINTS.INVENTORY_BROWSE_EXPORT,
    requestBody: {
      preset,
      filters,
      query,
      sortRules,
      exportType,
      excludedIds,
      hiddenColumns,
      salesLocationChoices
    }
  });
};
